import React, { Component } from 'react';
import * as $ from 'jquery';
import Payment from './Payment.js';
import PromocodeDialog from './PromocodeDialog.js';
import SuccessDialog from './SuccessDialog.js';
import Summary from './Summary.js';
import axios from 'axios';
import { ERRORS } from './PromocodeDialog.js';
import { Redirect } from 'react-router-dom';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { USER_TYPE } from '../../../App.js';
import HorasReservaciones from '../../../components/Balance/HorasReservaciones';

//ecommerce analytics
import ReactGA from 'react-ga';
ReactGA.initialize([
  { trackingId: 'UA-39921274-7', gaOptions: { name: 'IOSOffices' } }
], { debug: false, alwaysSendToDefaultTracker: false });

ReactGA.plugin.require('ec');

let cancelToken;

class PaymentContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState(props);
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    this.setModalListener();
    this.reload();
    this.getConekta({
      token_id: this.props.getTokenId(),
      razon_social: this.state.razon_social.rz
    });
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  getConekta = (params) => {
    this.props.post(
      "/getConnekta",
      params,
      (response) => this.didRazonSocial(response),
      (error) => this.didRazonSocialError(error),
      cancelToken
    );
  }

  didRazonSocial = (response) => {
    response ?
      response.conekta_public_key ? (
        window.Conekta.setPublicKey(response.conekta_public_key)
      ) : (
        window.Conekta.setPublicKey(process.env.REACT_APP_CONEKTA_KEY)
      )
      : null
  }

  didRazonSocialError = (error) => {
    alert(error.message);
  }

  addPromocode = (params) => {
    this.props.post(
      "/addPromocode",
      params,
      this.didAddPromocode,
      (_, type) => this.handlePromocodeError(type),
      cancelToken
    );
  }

  getFacturas = (params) => {
    this.props.post(
      "/getFacturas",
      params,
      (response) => this.didGetFacturas(response),
      (error) => this.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetFacturas = (response) => {
    if (response) {
      this.setState({
        street: response.calle + " " + response.numero_exterior,
        neighborhood: response.colonia,
        po: response.codigo_postal,
        city: response.municipio,
        state: response.estado,
      });
    }
  }

  didAddPromocode = () => {
    $('#modalPromocode').modal('hide');

    if (this.props.getTokenSession()) {
      this.getProfile({
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession()
      });
    }
    this.reload();
  }

  didGetPaymentDetails = (response) => {
    this.setState({ paymentDetails: response });
    this.setState({ someDays: response.variosDias });
  }

  didGetProfile = (response) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { email: response.email },
        { phone: response.phone }
      )
    });
    this.props.user.balance = response.balance;
    this.props.user.credits = response.credits;
    this.state.user.no_account = false;
  }

  didPayRoom = (response) => {

    const isMember = this.state.user.member !== USER_TYPE.GUEST;
    const userType = isMember ? "member" : "guest";

    if (userType == "guest") {

      window.ga('send', 'event', 'Reservations', 'pay', userType);
      var params = JSON.parse(localStorage.getItem("params"));
      this.sendToGoogleAnalyticsEcommerce(params, response);
    }

    $('#btnSuccess').click();
  }

  sendToGoogleAnalyticsEcommerce = (params, response) => {

    ReactGA.plugin.execute('ec', 'addProduct', {
      id: params.reservation_id,
      sku: params.reservation_title,
      name: params.reservation_title,
      price: response.total,
      category: params.reservation_title,
      quantity: '1',
      brand: params.reservation_title,
      list_name: 'Search Results'
    }
    );

    ReactGA.plugin.execute('ec', 'setAction', 'purchase', {
      id: params.reservation_id,
      affiliation: '​IOSOffices​',
      revenue: response.total,
      shipping: 0,
      tax: 0,
      currency: "MXN",
    }
    );

    //ReactGA.pageview('/payment');
    //ReactGA.plugin.execute('ec','send');
    ReactGA.plugin.execute('ec', 'clear');

  }

  getInitState = (props) => {
    return {
      cardCvc: "",
      cardMonth: "",
      cardName: "",
      cardNumber: "",
      cardYear: "",
      city: "",
      country: "",
      error: "",
      isPaying: false,
      neighborhood: "",
      paymentDetails: null,
      po: "",
      promocode: "",
      promocodeError: "",
      reservationOccupancy: "",
      reservationTitle: "",
      state: "",
      number: "",
      street: "",
      toHistory: false,
      user: props.user,
      someDays: false,
      razon_social: JSON.parse(this.props.location.state.center),
      SaldoTotal: "",
      TotalHrsChicas: "",
      TotalHrsChicasDisponibles: "",
      TotalHrsGrandes: "",
      TotalHrsGrandesDisponibles: "",
      TotalHrsEspecialesGrandesDisponibles: "",
      TotalHrsEspecialesChicasDisponibles: "",
      hrsChicasUtilizadas: "",
      hrsGrandesUtilizadas: "",
      hrsEspecialesGrandesUtilizadas: "",
      hrsEspecialesChicasUtilizadas: ""
    };
  }

  getPaymentDetails = (params) => {
    this.props.post(
      "/getPaymentDetails",
      params,
      (response) => this.didGetPaymentDetails(response),
      (error) => this.handleErrorResponse(error),
      cancelToken
    );
  }

  getProfile = (params) => {
    this.props.post(
      "/getProfile",
      params,
      (response) => this.didGetProfile(response),
      (error) => this.handleErrorResponse(error),
      cancelToken
    );
  }

  getTokenParams = () => {
    return {
      "card": {
        "number": this.state.cardNumber.trim(),
        "name": this.state.cardName.trim(),
        "exp_year": "20" + this.state.cardYear.trim(),
        "exp_month": this.state.cardMonth.trim(),
        "cvc": this.state.cardCvc.trim(),
        "address": {
          "street1": this.state.street.trim(),
          "street2": this.state.neighborhood.trim(),
          "city": this.state.city.trim(),
          "state": this.state.state.trim(),
          "zip": this.state.po.trim(),
          "country": this.state.country.trim()
        }
      }
    }
  }

  handleCardCvc = (event) => {
    this.setState({ cardCvc: event.target.value });
  }

  handleCardMonth = (event) => {
    this.setState({ cardMonth: event.target.value });
  }

  handleCardName = (event) => {
    this.setState({ cardName: event.target.value });
  }

  handleCardNumber = (event) => {
    this.setState({ cardNumber: event.target.value });
  }

  handleCardYear = (event) => {
    this.setState({ cardYear: event.target.value });
  }

  handleCityChange = (event) => {
    this.setState({ city: event.target.value });
  }

  handleClearError = () => {
    this.setState({ error: "" });
  }

  handleClearPromocode = () => {
    this.setState({ promocodeError: "" });
  }

  handleCountryChange = (event) => {
    this.setState({ country: event.target.value });
  }

  handleEmailChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { email: event.target.value }
      )
    });
  }

  handleLastnameChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { lastname: event.target.value }
      )
    });
  }

  handleNameChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { name: event.target.value }
      )
    });
  }

  handleNeighborhoodChange = (event) => {
    this.setState({ neighborhood: event.target.value });
  }

  handlePaymentConekta = (params) => {
    const onSuccess = (token) => this.payRoom(
      Object.assign({},
        params,
        { token_conekta: token.id })
    );

    const onError = (error) => this.setState({
      error: error.message_to_purchaser,
      isPaying: false
    });

    window.Conekta.Token.create(
      this.getTokenParams(),
      (token) => onSuccess(token),
      (error) => onError(error)
    );
  }

  handlePaymentSubmit = (event) => {
    event.preventDefault();

    const isMember = this.state.user.member !== USER_TYPE.GUEST;
    const room = JSON.parse(this.props.location.state.room);

    const params = {
      email: this.state.user.email,
      name: this.state.user.name,
      lastname: this.state.user.lastname,
      phone: this.state.user.phone,
      reservation_id: this.props.location.state.reservationId,
      reservation_occupancy: this.state.reservationOccupancy,
      reservation_title: this.state.reservationTitle,
      room_type: room.room_type,
      razon_social: this.state.razon_social.rz,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    };
    localStorage.setItem("params", JSON.stringify(params));
    const callback = () => {
      if (!isMember) {
        this.handlePaymentConekta(params);
      } else {
        this.payRoom(params);
      }
    };

    this.setState({ isPaying: true }, callback);
  }

  handlePromocodeChange = (event) => {
    this.setState({ promocode: event.target.value, promocodeError: "" });
  }

  handlePromocodeClick = () => {
    $('#btnPromocode').click();
  }

  handlePromocodeError = (error) => {
    const { t } = this.props;
    switch (error) {
      default:
      case ERRORS.NOT_FOUND:
        this.setState({ promocodeError: t('dashboard.room_payment.promocode_not_found') });
        break;
      case ERRORS.REDEEMED:
        this.setState({ promocodeError: t('dashboard.room_payment.promocode_redeemed') });
        break;
      case ERRORS.UNAVAILABLE:
        this.setState({ promocodeError: t('dashboard.room_payment.promocode_unavailable') });
        break;
      case ERRORS.UNREDEEMABLE:
        this.setState({ promocodeError: t('dashboard.room_payment.promocode_unredeemable') });
        break;
    }
  }

  handlePromocodeSubmit = (event) => {
    event.preventDefault();

    const room = JSON.parse(this.props.location.state.room);
    this.addPromocode({
      promocode: this.state.promocode,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      email: this.state.user.email,
      reservation_id: this.props.location.state.reservationId,
      room_type: room.room_type,
    });
  }

  handleReservationOccupancy = (event) => {
    this.setState({ reservationOccupancy: event.target.value });
  }

  handlePhoneChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { phone: event.target.value }
      )
    });
  }

  handlePoChange = (event) => {
    this.setState({ po: event.target.value });
  }

  handleReservationTitle = (event) => {
    this.setState({ reservationTitle: event.target.value });
  }

  handleStateChange = (event) => {
    this.setState({ state: event.target.value });
  }

  handleStreetChange = (event) => {
    this.setState({ street: event.target.value });
  }

  payRoom = (params) => {
    this.props.post(
      "/payRoom",
      params,
      (response) => this.didPayRoom(response),
      (error, _, conekta_msj, msg) => {
        localStorage.removeItem("params");
        this.setState({ isPaying: false });
        if (conekta_msj) { alert(msg); } else { this.handleErrorResponse(error); }
      },
      cancelToken,
      () => this.setState({ isPaying: false })
    );
  }

  reload = () => {
    const room = JSON.parse(this.props.location.state.room);

    if (this.props.getTokenSession()) {
      this.getProfile({
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession()
      });
    }

    this.getPaymentDetails({
      reservation_id: this.props.location.state.reservationId,
      room_type: room.room_type,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

    this.getFacturas({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    })

    this.getProfile({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  getProfile = (params) => {
    this.props.post(
      "/getProfileUser",
      params,
      (response) => this.didGetProfile(response),
      (error) => this.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetProfile = (response) => {
    this.getHours({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      empresa_id: response.empresa_id
    });
  }

  getHours = (params) => {
    this.props.post(
      "/gethours",
      params,
      (response) => this.didGetHours(response),
      (error) => this.handleErrorHoursResponse(error),
      cancelToken
    );
  }

  didGetHours = (response) => {
    this.setState({
      SaldoTotal: response.SaldoTotal,
      TotalHrsChicas: response.TotalHrsChicas,
      TotalHrsChicasDisponibles: response.TotalHrsChicasDisponibles,
      TotalHrsGrandes: response.TotalHrsGrandes,
      TotalHrsGrandesDisponibles: response.TotalHrsGrandesDisponibles,
      TotalHrsEspecialesGrandesDisponibles: response.TotalHrsEspecialesGrandesDisponibles,
      TotalHrsEspecialesChicasDisponibles: response.TotalHrsEspecialesChicasDisponibles,
      hrsChicasUtilizadas: response.hrsChicasUtilizadas,
      hrsGrandesUtilizadas: response.hrsGrandesUtilizadas,
      hrsEspecialesGrandesUtilizadas: response.hrsEspecialesGrandesUtilizadas,
      hrsEspecialesChicasUtilizadas: response.hrsEspecialesChicasUtilizadas
    })
  }

  handleErrorResponse = (error) => {
    console.error(error)
  }

  setModalListener = () => {
    $('#modalPromocode').on('hidden.bs.modal', () => {
      this.setState({ promocode: "" });
    });

    $('#modalSuccess').on('hidden.bs.modal', () => {
      window.fbq('track', 'Purchase');
      this.setState({ toHistory: true });
    });
  }

  renderPayment = () => {
    return (
      <Payment
        cardMonth={this.state.cardMonth}
        cardName={this.state.cardName}
        cardNumber={this.state.cardNumber}
        cardCvc={this.state.cardCvc}
        cardYear={this.state.cardYear}
        city={this.state.city}
        country={this.state.country}
        error={this.state.error}
        handleCardCvc={this.handleCardCvc}
        handleCardMonth={this.handleCardMonth}
        handleCardName={this.handleCardName}
        handleCardNumber={this.handleCardNumber}
        handleCardYear={this.handleCardYear}
        handleCityChange={this.handleCityChange}
        handleClearError={this.handleClearError}
        handleCountryChange={this.handleCountryChange}
        handleEmailChange={this.handleEmailChange}
        handleLastnameChange={this.handleLastnameChange}
        handleNameChange={this.handleNameChange}
        handleNeighborhoodChange={this.handleNeighborhoodChange}
        handlePaymentSubmit={this.handlePaymentSubmit}
        handleReservationOccupancy={this.handleReservationOccupancy}
        handlePhoneChange={this.handlePhoneChange}
        handlePoChange={this.handlePoChange}
        handleReservationTitle={this.handleReservationTitle}
        handleStateChange={this.handleStateChange}
        handleStreetChange={this.handleStreetChange}
        isPaying={this.state.isPaying}
        neighborhood={this.state.neighborhood}
        po={this.state.po}
        reservationOccupancy={this.state.reservationOccupancy}
        reservationTitle={this.state.reservationTitle}
        room={JSON.parse(this.props.location.state.room)}
        state={this.state.state}
        street={this.state.street}
        user={this.state.user} />
    );
  }

  renderPromocodeDialog = () => {
    return (
      <PromocodeDialog
        handleClearPromocode={this.handleClearPromocode}
        handlePromocodeChange={this.handlePromocodeChange}
        handlePromocodeSubmit={this.handlePromocodeSubmit}
        promocode={this.state.promocode}
        promocodeError={this.state.promocodeError}
        user={this.state.user} />
    );
  }

  renderSuccessDialog = () => {
    return (
      <SuccessDialog
        room={JSON.parse(this.props.location.state.room)}
        user={this.state.user} />
    );
  }

  renderSummary = () => {
    return (
      <Summary
        center={JSON.parse(this.props.location.state.center)}
        handlePromocodeClick={this.handlePromocodeClick}
        paymentDetails={this.state.paymentDetails}
        room={JSON.parse(this.props.location.state.room)}
        user={this.props.user} />
    );
  }

  render() {
    if (this.state.toHistory) {
      return <Redirect to={{
        pathname: this.props.user.no_account ? "/store" : "/history",
        state: { reservationId: this.props.location.state.reservationId }
      }} />;
    }
    const { t } = this.props;
    const user = this.props.user;
    return (
      <div className='container'>
        <div className="content-resvations">
          <div className="">
            <div className="">
              <br />
              <h2 className="page-header">{t('dashboard.reservations.heading')}</h2>
            </div>
            {this.props.user.memberId
              ? (
                <div className='contHoras2 form-group'>
                  <HorasReservaciones
                      tipoDeSala = {t('dashboard.reservations.big_remaining')}
                      horasDisponibles = { this.state.TotalHrsGrandesDisponibles || 0 }
                      horasUsadas = { this.state.hrsGrandesUtilizadas || 0 }
                  >
                  </HorasReservaciones>
                  <HorasReservaciones
                      tipoDeSala = {t('dashboard.reservations.special_big_remaining')}
                      horasDisponibles = { this.state.TotalHrsEspecialesGrandesDisponibles || 0 }
                      horasUsadas = { this.state.hrsEspecialesGrandesUtilizadas || 0 }
                  >
                  </HorasReservaciones>
                  <HorasReservaciones
                      tipoDeSala = {t('dashboard.reservations.small_remaining')}
                      horasDisponibles = { this.state.TotalHrsChicasDisponibles || 0 }
                      horasUsadas = { this.state.hrsChicasUtilizadas || 0 }
                  >
                  </HorasReservaciones>
                  <HorasReservaciones
                      tipoDeSala = {t('dashboard.reservations.special_small_remaining')}
                      horasDisponibles = { this.state.TotalHrsEspecialesChicasDisponibles || 0 }
                      horasUsadas = { this.state.hrsEspecialesChicasUtilizadas || 0 }
                  >
                  </HorasReservaciones>
              </div>
              )
              : null
            }

          </div>
          <div className="container-resvations">
            <div className="row">
              <div className="col-md-6 col-md-push-6 col-lg-4 col-lg-push-8">
                {this.state.paymentDetails && this.renderSummary()}
              </div>
              <div className="col-md-6 col-md-pull-6 col-lg-8 col-lg-pull-4 content-resvations-search">
                {this.state.user && this.renderPayment()}
              </div>
            </div>
          </div>
          {this.renderPromocodeDialog()}
          {this.renderSuccessDialog()}
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(PaymentContainer);



// WEBPACK FOOTER //
// ./src/dashboard/reservations/payment/PaymentContainer.js